import { Component, OnInit } from '@angular/core';
import { TableHeader } from 'src/app/models/tableheader.model';
import { PanelService } from 'src/app/services/panel.service';

@Component({
  selector: 'app-stats-table',
  templateUrl: './stats-table.component.html',
  styleUrls: ['./stats-table.component.scss'],
})
export class StatsTableComponent implements OnInit {
  stats: {
    name: string;
    count: number;
    sumBonificada: number;
  }[] = [];
  loadTable: boolean = false;
  statsProcessed:
    | {
        lite: number;
        basic: number;
        jupiter: number;
        sumBonificada: number;
      }
    | undefined;
  //-------------------- Table Header Configurations--------------------
  statsTableHeader: TableHeader[] = [
    {
      id: 'lite',
      text: 'Lite',
      percentageWidth: 25,
      isOrderByVisible: false,
    },
    {
      id: 'basic',
      text: 'Basico',
      percentageWidth: 25,
      isOrderByVisible: false,
    },
    {
      id: 'jupiter',
      text: 'Jupiter',
      percentageWidth: 25,
      isOrderByVisible: false,
    },
    {
      id: 'bonificated',
      text: 'Bonificados',
      percentageWidth: 25,
      isOrderByVisible: false,
    },
  ];

  constructor(public panelService: PanelService) {}

  ngOnInit(): void {
    this.getStats();
  }

  getStats() {
    this.panelService.getClientsSummary().then(
      (res: any) => {
        if (res?.data) {
          res.data.map(
            (statElement: {
              name: string;
              count: number;
              sumBonificada: number;
            }) => {
              this.stats.push(statElement);
            }
          );
        }
        if (this.stats) {
          let auxSum =
            this.stats[0].sumBonificada +
            this.stats[1].sumBonificada +
            this.stats[2].sumBonificada;
          this.statsProcessed = {
            lite: 0,
            basic: 0,
            jupiter: 0,
            sumBonificada: auxSum,
          };
          this.stats.forEach((element) => {
            if (this.statsProcessed) {
              if (element.name == 'Lite')
                this.statsProcessed.lite = element.count;
              if (element.name == 'Básica')
                this.statsProcessed.basic = element.count;
              if (element.name == 'Júpiter')
                this.statsProcessed.jupiter = element.count;
            }
          });
        }
        this.loadTable = true;
      },
      (error: Error) => {
        console.log(error);
      }
    );
  }
}
